var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('LineGraph',{staticClass:"pa-3",attrs:{"chartdata":_vm.dataCollection,"y-label":_vm.yAxisLabel}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }